"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = useDonationListener;

var _react = require("react");

var _contexts = require("../contexts");

function useDonationListener() {
  const {
    donationListenerEnabled,
    hooks
  } = (0, _react.useContext)(_contexts.Settings);
  const [isFeedbackShown, setIsFeedbackShown] = (0, _react.useState)(false);
  (0, _react.useEffect)(() => {
    if (!donationListenerEnabled) return;

    const handlePostMessage = ev => {
      if (ev.data && ev.data.type === "donationFinished") {
        // console.log("Donation registered ...");
        setIsFeedbackShown(true);
        if (typeof hooks.onDonationFinished === "function") hooks.onDonationFinished();
      }
    };

    window.addEventListener("message", handlePostMessage, false);
    return () => window.removeEventListener("message", handlePostMessage);
  }, [donationListenerEnabled, hooks]);
  return [isFeedbackShown, () => setIsFeedbackShown(false)];
}